<template>
  <v-dialog
    persistent
    v-model="dialog"
    @input="resetParam"
    v-if="dialog"
    max-width="750px">
    <div class="layerPopup">
      <div class="layerTit">
        グループ{{pageType}}
      </div>
      <div class="layerContent large">
        <div class="groupDialogBox">
          <dl class="groupList">
            <dt>検索結果 ({{customerLength}})</dt>
          </dl>
          <table class="UXTbl">
            <colgroup>
              <col style="width:120px;" />
              <col style="width:245px" />
              <col style="width:120px;" />
              <col />
            </colgroup>
            <tbody>
            <tr v-if="customerStat === 'LINE'">
              <th class="require-after">チャネル</th>
              <td colspan="3">
                <v-select
                  v-model="lineChannel"
                  :items="lineChannelList"
                  item-text="name"
                  item-value="value"
                  placeholder="選択してください。"
                  class="UXselect"
                  hide-details
                  outline
                  solo
                  attach
                  :disabled="dialogType !== 'NEW'"
                  @change="getCustomerSearch"
                  no-data-text="データがありません。"
                ></v-select>
              </td>
            </tr>
            <tr>
              <th class="require-after" :class="{ 'disabled': !selectFlg }">グループ名</th>
              <td>
                <v-text-field
                  v-model="groupName"
                  placeholder="グループ名記入"
                  class="UXinput"
                  outline
                  solo
                  :disabled="pageType !== '追加' || !selectFlg "
                  :rules="[rules.required]"
                ></v-text-field>
              </td>
              <th :class="{ 'disabled': !selectFlg }">会員状態</th>
              <td>
                <v-checkbox
                  v-model="customerMemberFlg"
                  value="ENABLE"
                  label="会員"
                  class="UXcheckbox gray left"
                  hide-details
                  @change="getCustomerSearch"
                  :disabled="!selectFlg"
                ></v-checkbox>
                <v-checkbox
                  v-model="customerMemberFlg"
                  value="DISABLE"
                  label="非会員"
                  class="UXcheckbox gray left"
                  hide-details
                  :disabled="!selectFlg"
                  @change="getCustomerSearch"
                ></v-checkbox>
              </td>
            </tr>
            <tr>
              <th :class="{ 'disabled': !selectFlg }">エリア</th>
              <td>
                <v-autocomplete
                  v-model="customerArea"
                  :items="customerAreaList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="エリア検索"
                  :disabled="!selectFlg"
                  @change="getCustomerSearch"
                ></v-autocomplete>
              </td>
              <th v-if="customerStat !== 'LINE'" :class="{ 'disabled': !selectFlg }">使用OS</th>
              <td v-if="customerStat !== 'LINE'">
                <v-autocomplete
                  v-model="customerUseOs"
                  :items="customerUseOsList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="デバイス検索"
                  :disabled="!selectFlg"
                  @change="getCustomerSearch"
                ></v-autocomplete>
              </td>
              <td v-else colspan="2"></td>
            </tr>
            <tr>
              <th :class="{ 'disabled': !selectFlg }">訪問数</th>
              <td>
                <v-autocomplete
                  v-model="visitCount"
                  :items="visitCountList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="訪問数検索"
                  :disabled="!selectFlg"
                  @change="getCustomerSearch"
                ></v-autocomplete>
              </td>
              <th :class="{ 'disabled': !selectFlg }">平均利用額</th>
              <td>
                <v-autocomplete
                  v-model="avgAmount"
                  :items="avgAmountList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="平均利用額検索"
                  :disabled="!selectFlg"
                  @change="getCustomerSearch"
                ></v-autocomplete>
              </td>
            </tr>
            <tr v-if="customerStat === 'LINE'">
              <th :class="{ 'disabled': !selectFlg }">性別</th>
              <td>
                <v-checkbox
                  v-model="customerGenderInfo"
                  value="MALE"
                  label="男性"
                  class="UXcheckbox gray left"
                  hide-details
                  :disabled="!selectFlg"
                  @change="getCustomerSearch"
                ></v-checkbox>
                <v-checkbox
                  v-model="customerGenderInfo"
                  value="FEMALE"
                  label="女性"
                  class="UXcheckbox gray left"
                  hide-details
                  :disabled="!selectFlg"
                  @change="getCustomerSearch"
                ></v-checkbox>
              </td>
              <th :class="{ 'disabled': !selectFlg }">年齢</th>
              <td>
                <v-autocomplete
                  v-model="customerAgeInfo"
                  :items="customerAgeInfoList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="年齢検索"
                  :disabled="!selectFlg"
                  @change="getCustomerSearch"
                ></v-autocomplete>
              </td>
            </tr>
            <tr>
              <th :class="{ 'disabled': !selectFlg }">最終接続日</th>
              <td>
              <date-picker :startDate="startDate" :endDate="endDate" :disabledDates="['afterToday']" @child="updateDatePicker" class="date-picker" v-show="startDate !== ''" :disabled="!selectFlg"></date-picker>
              </td>
              <th :class="{ 'disabled': !selectFlg }">{{ sectionName }}</th>
              <td>
                <v-select
                  v-model="accessCount"
                  :items="accessCountList"
                  @change="getCustomerSearch"
                  item-text="name"
                  item-value="value"
                  class="UXselect type-select"
                  :placeholder="sectionName"
                  hide-details
                  outline
                  multiple
                  chips
                  small-chips
                  :disabled="!selectFlg"
                  no-data-text="データがありません。"
              ></v-select>
              </td>
            </tr>
            <tr>
              <th :class="{ 'disabled': !selectFlg }">タグ</th>
              <td colspan="3">
              <v-autocomplete
                ref="tagInp"
                v-model="customerTags"
                :items="customerTagsList"
                item-text="name"
                item-value="value"
                class="UXselect"
                outline
                multiple
                chips
                small-chips
                placeholder="タグ検索"
                @change="getCustomerSearch"
                :disabled="!selectFlg"
                hide-no-data
             ></v-autocomplete>
              </td>
            </tr>
            </tbody>
          </table>
          <span class="requiredTxt require-before">必須項目</span>
          <div class="cenBtn" style="padding:30px 0 20px 0;">
            <v-btn outline round large class="UXbtn widthAuto" @click="close">キャンセル</v-btn>
            <v-btn round dark large color="#ff8c8c" class="UXbtn widthAuto" :loading="loading" :disabled="loading || !selectFlg" @click="alertModal" >{{pageType}}</v-btn>
          </div>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex'
import Dimmed from '@/components/Dimmed'

export default {
  name: 'groupDialog',
  components: {
    Dimmed
  },
  computed: {
    ...mapGetters([
      'currentBrandId'
    ]),
    pageType () {
      return this.dialogType === 'NEW' ? '追加' : '変更'
    },
    channelType () {
      return this.customerStat === 'LINE' ? 'LINE' : 'WEB_CHAT'
    },
    sectionName () {
      return this.customerStat === 'LINE' ? '問合せ数' : 'セッション数'
    },
    selectFlg () {
      return !!this.lineChannel || this.customerStat === 'WEBSITE'
    }
  },
  props: {
    customerAreaList: Array,
    customerUseOsList: Array,
    customerTagsList: Array,
    customerStat: String,
    webChatModuleChannelId: Number,
    selectGroupId: [String, Number],
    dialog: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: 'NEW'
    }
  },
  data () {
    return {
      startDate: '',
      endDate: '',
      tagInput: '',
      localTags: [],
      groupName: '',
      loading: false,
      accessCount: [],
      accessCountList: [
        {name: '0 - 5回', value: '0'},
        {name: '6 - 20回', value: '6'},
        {name: '21 - 99回', value: '21'},
        {name: '100回以上', value: '100'}
      ],
      customerArea: [],
      customerUseOs: [],
      customerTags: [],
      customerMemberFlg: [],
      customerList: [],
      visitCount: [],
      visitCountList: [
        {name: '0 - 1回', value: '1'},
        {name: '2 - 9回', value: '2'},
        {name: '10回以上', value: '10'}
      ],
      avgAmount: [],
      avgAmountList: [
        {name: '0 - 1,000円', value: '0'},
        {name: '1,001 - 10,000円', value: '1001'},
        {name: '10,001円以上', value: '10001'}
      ],
      rules: {
        required: v => !!v || '必須情報です。'
      },
      searhLoading: false,
      customerLength: 0,
      customerGenderInfo: [],
      customerAgeInfo: [],
      customerAgeInfoList: [
        {name: '14歳以下', value: '14'},
        {name: '15 - 19歳', value: '15'},
        {name: '20 - 24歳', value: '20'},
        {name: '25 - 29歳', value: '25'},
        {name: '30 - 34歳', value: '30'},
        {name: '35 - 39歳', value: '35'},
        {name: '40 - 44歳', value: '40'},
        {name: '45 - 49歳', value: '45'},
        {name: '50歳以上', value: '50'}
      ],
      lineChannel: null,
      lineChannelList: []
    }
  },
  created () {
  },
  mounted () {

  },
  watch: {
    dialog (val) {
      if (!val) {
      } else {
        this.getGroupInfo()
        if (this.customerStat === 'LINE') {
          this.getLineChannelList()
        } else {
          this.getCustomerSearch()
        }
      }
    }
  },
  methods: {
    close (type) {
      this.resetParam()
      this.$emit('dialogClose', type, false, true)
    },
    alertModal () {
      if (!this.groupName) {
        this.$alertMsg('グループ名を入力してください')
        return false
      }
      this.$eventBus.$emit('DialogPopup', {
        useDialog: true,
        getBtnCount: 2,
        messageHTML: `<dl class="txt"><dd>グループを${this.pageType}しますか？</dd></dl>`,
        getButtonEvent: () => this.apply()
      })
    },
    apply () {
      let searchData = {
        area: this.customerArea,
        os: this.customerUseOs,
        memberflg: this.customerMemberFlg,
        tag: this.customerTags,
        lastVisitDateFrom: this.startDate,
        lastVisitDateTo: this.endDate,
        accessCount: this.accessCount,
        visitCount: this.visitCount,
        avgAmount: this.avgAmount,
        customerGenderInfo: this.customerGenderInfo,
        customerAgeInfo: this.customerAgeInfo,
        moduleChannelId: (this.customerStat === 'LINE') ? this.lineChannel : this.webChatModuleChannelId
      }
      let resultData = {
        customerId: this.customerList
      }
      this.axios.post(`/api/groupCustomerInfo/saveGroup`, {
        brandId: this.currentBrandId,
        groupName: this.groupName,
        moduleChannelId: (this.customerStat === 'LINE') ? this.lineChannel : this.webChatModuleChannelId,
        resultData: JSON.stringify(resultData),
        searchData: JSON.stringify(searchData),
        customerType: this.channelType,
        groupCustomerInfoId: this.dialogType === 'NEW' ? null : this.selectGroupId // 그룹 아이디 있을경우 등록 아닌 변경
      }).then(res => {
        let data = res.data.data
        if (res.status !== 200 || res.data.code !== 0) {
          this.$alertMsg(res.data.message)
        } else {
          this.$alertMsg(`グループが${this.pageType}されました。`)
          this.close()
          this.$emit('getGroupListPass', data.groupCustomerInfoId)
        }
      })
    },
    resetParam () {
      this.customerArea = []
      this.customerMemberFlg = ['DISABLE', 'ENABLE']
      this.customerUseOs = []
      this.groupName = ''
      this.customerTags = []
      this.localTags = []
      this.customerList = []
      this.startDate = ''
      this.endDate = ''
      this.accessCount = []
      this.visitCount = []
      this.avgAmount = []
      this.customerGenderInfo = []
      this.customerAgeInfo = []
      this.lineChannelList = []
      this.lineChannel = null
    },
    getSelectedArrayValue (covertData) {
      const arrayData = []
      if (covertData) {
        covertData.forEach((i) => {
          arrayData.push(i)
        })
      }
      return arrayData
    },
    getCustomerSearch () {
      if (this.searhLoading) {
        return false
      } else {
        this.axios.get('/api/customer/groupSearchCustomerInfoData', {
          params: {
            brandId: this.currentBrandId,
            moduleChannelId: this.lineChannel,
            customerNational: encodeURI(this.getSelectedArrayValue(this.customerNational)),
            customerUseOs: encodeURI(this.getSelectedArrayValue(this.customerUseOs)),
            customerUseDevice: encodeURI(this.getSelectedArrayValue(this.customerUseDevice)),
            customerUseArea: encodeURI(this.getSelectedArrayValue(this.customerArea)),
            customerMemberFlg: encodeURI(this.getSelectedArrayValue(this.customerMemberFlg)),
            customerTag: encodeURI(this.getSelectedArrayValue(this.customerTags)),
            customerStat: this.channelType,
            lastVisitDateFrom: this.startDate,
            lastVisitDateTo: this.endDate,
            accessCount: encodeURI(this.getSelectedArrayValue(this.accessCount)),
            visitCount: encodeURI(this.getSelectedArrayValue(this.visitCount)),
            avgAmount: encodeURI(this.getSelectedArrayValue(this.avgAmount)),
            genderInfo: encodeURI(this.getSelectedArrayValue(this.customerGenderInfo)),
            ageInfo: encodeURI(this.getSelectedArrayValue(this.customerAgeInfo))
          }
        }).then(result => {
          if (result.status !== 200 || result.data.code !== 0) {
            console.log(result.data.message)
          } else {
            let data = result.data.data
            this.searhLoading = true
            this.customerList = data.customerIds
            this.customerLength = this.customerList.length
          }
        }).catch(err => {
          console.log(err.message)
        }).finally(() => {
          this.searhLoading = false
        })
      }
    },
    getGroupInfo () {
      if (this.dialogType === 'ChangeSetting') {
        this.axios.get('/api/groupCustomerInfo/getGroupInfo', {
          params: {
            groupCustomerId: this.selectGroupId
          }
        }).then(result => {
          if (result.status !== 200 || result.data.code !== 0) {
            console.log(result.data.message)
          } else {
            let data = result.data.data
            let searchData = JSON.parse(data.searchData)
            let customerData = JSON.parse(data.resultData)
            this.groupName = data.groupName
            this.customerList = customerData.customerId
            this.customerLength = data.customerCount
            this.customerUseOs = searchData.os
            this.customerArea = searchData.area
            this.customerMemberFlg = searchData.memberflg
            this.customerTags = searchData.tag
            this.startDate = searchData.lastVisitDateFrom
            this.endDate = searchData.lastVisitDateTo
            this.accessCount = searchData.accessCount
            this.visitCount = searchData.visitCount
            this.avgAmount = searchData.avgAmount
            this.customerGenderInfo = searchData.customerGenderInfo
            this.customerAgeInfo = searchData.customerAgeInfo
            this.lineChannel = searchData.moduleChannelId
          }
        }).catch(err => {
          console.log(err.message)
        })
      }
    },
    updateDatePicker (date) {
      this.startDate = date.start
      this.endDate = date.end
      this.getCustomerSearch()
    },
    getLineChannelList () {
      this.$http({
        method: 'GET',
        url: `/api/v2/module-channels/${this.currentBrandId}/line`
      }).then(result => {
        const res = result.data
        if (res.code === 0) {
          res.data.forEach(d => {
            this.lineChannelList.push({
              name: d.nickName,
              value: d.id
            })
          })
        } else {
          this.$alertMsg(result.data.message)
        }
      }).catch(err => {
        this.$alertMsg(err)
      })
    }
  }
}
</script>

<style lang="scss" scope>
.groupDialogBox {
  dl.groupList {
    padding-bottom: 10px;
    dt {
      padding-bottom:5px;
      color:$gray-8;
      font-weight: bold;
      font-size: 14px;
    }
    dd {
      border:1px solid #C4C4C4;
      border-radius: 3px;
      ul {
        padding:10px;
        height:140px;
        overflow-y:auto;
        li {
          padding: 0 5px 5px 0;
          list-style: none;
          display: inline-flex;
          justify-content: flex-start;
          align-items: center;
          span {
            padding:0 10px;
            display:inline-block;
            height:35px;
            line-height:35px;
            font-size: 14px;
            color: $gray-8;
            background: $gray-2;
            border-radius: 3px;
          }
        }
      }
    }
  }
  .requiredTxt {
    display: flex;
    justify-content: end;
    font-size: 11px;
    color: #939393;
  }
  td .v-input--is-disabled input {
    color: #aaa;
  }
  .UXTbl tbody td {
    height: 65px;
  }
  .left {
    float : left;
    padding-right: 10px;
  }
  .v-chip--select-multi {
    background: #E8E8E8;
  }
  .disableColor {
    opacity: 0.4;
  }
  .v-select.v-text-field input::placeholder {
    color: #555555;
  }
  .UXselect {
    .v-input__slot {
        height: auto !important;
        padding: 0px 5px 0px 5px;
        .v-select__selections {
          min-height: 25px !important;
          max-height: 150px !important;
          padding-top: 0px !important;
          input {
            padding: 0;
          }
        }
      }
  }
  /* 비활성화된 행에 적용할 CSS 스타일 정의 */
  .disabled {
    opacity: 0.5;
    pointer-events: none; /* 클릭 및 이벤트 비활성화 */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menus/customer/components/groupDialog.vue